import {
  type BlockAddSubProblemState,
  createBlockAddSubProblemState,
  populateBlockAddSubProblems,
} from '../core/blockAddSubProblems';
import { type BlockFlag, blockVariantConfig } from '../core/blockConfig';
import {
  type BlockMulDivProblemState,
  createBlockMulDivProblemState,
  populateBlockMulDivProblems,
} from '../core/blockMulDivProblems';
import type { ProblemPool } from '../core/deal';

import {
  type PopulateProblemsArgs,
  type RulesGame,
  type UseRulesFamilyGameOptions,
  useRulesBoardGame,
} from './useRulesBoardGame';

type BlockProblemState = BlockAddSubProblemState & BlockMulDivProblemState;

function createBlockProblemState(
  previous?: BlockProblemState,
): BlockProblemState {
  return {
    ...createBlockAddSubProblemState(previous),
    ...createBlockMulDivProblemState(),
  };
}

function populateBlockProblems({
  flag,
  ...args
}: PopulateProblemsArgs<BlockFlag, BlockProblemState>): ProblemPool {
  return flag === 1 || flag === 2
    ? populateBlockAddSubProblems({ flag, ...args })
    : populateBlockMulDivProblems({ flag, ...args });
}

/**
 * Progression, pacing and problem selection for the 4x4 VIF block board. A
 * thin wrapper around the family-generic `useRulesBoardGame` - the four block
 * flags share one config and differ only in where their problems come from.
 */
export function useBlockGame(
  options: UseRulesFamilyGameOptions<BlockFlag>,
): RulesGame {
  return useRulesBoardGame({
    ...options,
    resolveConfig: blockVariantConfig,
    createProblemState: createBlockProblemState,
    populateProblems: populateBlockProblems,
  });
}
